import { render } from "./BCalendar.vue?vue&type=template&id=d47aec2a"
import script from "./BCalendar.vue?vue&type=script&lang=js"
export * from "./BCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__